import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-useriddefinition',
  templateUrl: './useriddefinition.component.html',
  styleUrls: ['./useriddefinition.component.scss']
})
export class UseriddefinitionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
